import script from './SdsInputCurrency.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsBaseInput',{ref:"baseInputRef",staticClass:"sds-input-currency",attrs:{"name":_vm.name,"value":_vm.value != null ? _vm.displayValue : undefined,"label":_vm.label,"isDisabled":_vm.isDisabled,"isReadOnly":_vm.isReadOnly,"isClearable":_vm.isClearable,"message":_vm.message,"status":_vm.status,"autocomplete":_vm.autocomplete,"dataTestId":_vm.dataTestId,"type":"text","inputmode":"decimal","alignment":"right"},on:{"beforeinput":_vm.handleBeforeInputEdgeCases,"update:value":_vm.handleInput,"click":_vm.handleInputClick,"keypress":_vm.handleKeyPress,"focus":function($event){return _vm.setIsFocused(true, $event)},"blur":function($event){return _vm.setIsFocused(false, $event)},"cleared":function($event){return _vm.$emit('cleared')}},scopedSlots:_vm._u([(_vm.unit)?{key:"prepend",fn:function(){return [(_vm.isFocused || !!_vm.value)?_c('div',{staticClass:"sds-input-currency__unit"},[_vm._v("\n            "+_vm._s(_vm.unit)+"\n        ")]):_vm._e()]},proxy:true}:null],null,true)})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0f3b3fd8_0", { source: ".sds-input-currency__unit[data-v-0f3b3fd8]{position:relative;top:8px;margin-left:-8px;color:var(--system-text-on-elevation-primary);font-weight:600;font-size:16px;line-height:1.25;text-transform:uppercase}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-0f3b3fd8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
